import { BoardTypeChoices } from 'src/app/model/product/board/board-part';
import { IPBoardPlacementTypeChoices } from 'src/app/model/product/ip-board/ip-board-placement-type';
import { SignMeasurementsChoices } from 'src/app/model/sign/enums/sign-measurements';
import { SignPlacementPrice } from 'src/app/model/sign/sign-placement-price/sign-placement-price';
import { ClientIPBoardAndPlacementHelper } from 'src/app/shared/project-components/client-project-form/base-project/client-ip-board-form/helper/client-ip-board-and-placement-helper';

export class SignPlacementPriceDetailHelper {
  private constructor() {}

  static calculateDesign(signPlacementPrice: SignPlacementPrice): void {
    if (
      signPlacementPrice.boardType == null ||
      signPlacementPrice.placementType == null
    ) {
      delete signPlacementPrice.designUrl;
      return;
    }
    if (
      signPlacementPrice.boardType.ordinal ===
      BoardTypeChoices.SINGLE_SIDED.ordinal
    ) {
      this.calculateSingleSidedDesign(signPlacementPrice);
    } else if (
      signPlacementPrice.boardType.ordinal ===
      BoardTypeChoices.DOUBLE_SIDED.ordinal
    ) {
      this.calculateDoubleSidedDesign(signPlacementPrice);
    } else if (
      signPlacementPrice.boardType.ordinal === BoardTypeChoices.V.ordinal
    ) {
      this.calculateVDesign(signPlacementPrice);
    } else {
      delete signPlacementPrice.designUrl;
    }
  }

  private static calculateSingleSidedDesign(
    signPlacementPrice: SignPlacementPrice
  ): void {
    if (
      signPlacementPrice.placementType.ordinal ===
      IPBoardPlacementTypeChoices.ATTACHED_TO_FACADE.ordinal
    ) {
      signPlacementPrice.designUrl =
        ClientIPBoardAndPlacementHelper.SINGLE_SIDED_PLACEMENT_OPTIONS.FACADE.previewUrl;
    } else if (
      signPlacementPrice.placementType.ordinal ===
      IPBoardPlacementTypeChoices.BALCONY.ordinal
    ) {
      signPlacementPrice.designUrl =
        ClientIPBoardAndPlacementHelper.SINGLE_SIDED_PLACEMENT_OPTIONS.BALCONY.previewUrl;
    } else if (
      signPlacementPrice.placementType.ordinal ===
      IPBoardPlacementTypeChoices.STRETCHED.ordinal
    ) {
      signPlacementPrice.designUrl =
        ClientIPBoardAndPlacementHelper.SINGLE_SIDED_PLACEMENT_OPTIONS.STRETCHED.previewUrl;
    } else if (
      signPlacementPrice.placementType.ordinal ===
      IPBoardPlacementTypeChoices.ON_POSTS.ordinal
    ) {
      signPlacementPrice.designUrl =
        ClientIPBoardAndPlacementHelper.SINGLE_SIDED_PLACEMENT_OPTIONS.ON_POSTS.previewUrl;
    } else if (
      signPlacementPrice.placementType.ordinal ===
      IPBoardPlacementTypeChoices.ON_STONES.ordinal
    ) {
      signPlacementPrice.designUrl =
        ClientIPBoardAndPlacementHelper.SINGLE_SIDED_PLACEMENT_OPTIONS.ON_STONES.previewUrl;
    } else {
      delete signPlacementPrice.designUrl;
    }
  }

  private static calculateDoubleSidedDesign(
    signPlacementPrice: SignPlacementPrice
  ): void {
    if (
      signPlacementPrice.placementType.ordinal ===
      IPBoardPlacementTypeChoices.ON_POSTS.ordinal
    ) {
      signPlacementPrice.designUrl =
        ClientIPBoardAndPlacementHelper.DOUBLE_SIDED_PLACEMENT_OPTIONS.ON_POSTS.previewUrl;
    } else if (
      signPlacementPrice.placementType.ordinal ===
      IPBoardPlacementTypeChoices.ON_STONES.ordinal
    ) {
      signPlacementPrice.designUrl =
        ClientIPBoardAndPlacementHelper.DOUBLE_SIDED_PLACEMENT_OPTIONS.ON_STONES.previewUrl;
    } else {
      delete signPlacementPrice.designUrl;
    }
  }

  private static calculateVDesign(
    signPlacementPrice: SignPlacementPrice
  ): void {
    if (
      signPlacementPrice.placementType.ordinal ===
      IPBoardPlacementTypeChoices.ATTACHED_TO_FACADE.ordinal
    ) {
      signPlacementPrice.designUrl =
        ClientIPBoardAndPlacementHelper.V_IP_BOARD_PLACEMENT_OPTIONS.FACADE.previewUrl;
    } else if (
      signPlacementPrice.placementType.ordinal ===
      IPBoardPlacementTypeChoices.BALCONY.ordinal
    ) {
      signPlacementPrice.designUrl =
        ClientIPBoardAndPlacementHelper.V_IP_BOARD_PLACEMENT_OPTIONS.BALCONY.previewUrl;
    } else if (
      signPlacementPrice.placementType.ordinal ===
      IPBoardPlacementTypeChoices.STRETCHED.ordinal
    ) {
      signPlacementPrice.designUrl =
        ClientIPBoardAndPlacementHelper.V_IP_BOARD_PLACEMENT_OPTIONS.STRETCHED.previewUrl;
    } else if (
      signPlacementPrice.placementType.ordinal ===
      IPBoardPlacementTypeChoices.ON_POSTS.ordinal
    ) {
      signPlacementPrice.designUrl =
        ClientIPBoardAndPlacementHelper.V_IP_BOARD_PLACEMENT_OPTIONS.ON_POSTS.previewUrl;
    } else if (
      signPlacementPrice.placementType.ordinal ===
      IPBoardPlacementTypeChoices.ON_STONES.ordinal
    ) {
      signPlacementPrice.designUrl =
        ClientIPBoardAndPlacementHelper.V_IP_BOARD_PLACEMENT_OPTIONS.ON_STONES.previewUrl;
    } else {
      delete signPlacementPrice.designUrl;
    }
  }
}

export const IP_BOARD_SIGN_MEASUREMENTS_CHOICES = {
  W70_H100: SignMeasurementsChoices.W70_H100,
  W100_H140: SignMeasurementsChoices.W100_H140
};

export const IP_BOARD_SIGN_MEASUREMENTS_CHOICE_ARRAY = Object.values(
  IP_BOARD_SIGN_MEASUREMENTS_CHOICES
);

export const DOUBLE_SIDED_PLACEMENT_CHOICES = {
  ON_POSTS: IPBoardPlacementTypeChoices.ON_POSTS,
  ON_STONES: IPBoardPlacementTypeChoices.ON_STONES
};

export const DOUBLE_SIDED_PLACEMENT_CHOICES_ARRAY = Object.values(
  DOUBLE_SIDED_PLACEMENT_CHOICES
);
